export enum FairplayerFallbackImageUi {
  EXCLUSIVE = 'EXCLUSIVE',
  FAN = 'FAN',
}
